import { COUNTRY_SCHOOL_STATS } from '@src/graphql/queries/country';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useCountryStats = ({ searchText }) => {
    const { page, setPage, pageSize, setPageSize, total, items: stats, loading, error, find, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        spec: { searchText },
        fetchQuery: COUNTRY_SCHOOL_STATS,
        dataProp: 'countrySchoolStats',
        initialPageSize: 10,
    });
    return {
        stats,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
